import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import ListingHeader from '../Components/ProductListing/ListingHeader';
import ProductListing from '../Components/ProductListing/ProductListing';
import LayoutSwitch from '../Components/ProductListing/LayoutSwitch';
import FilterMenu from '../Components/Filter/FilterMenu';
import Select from '../Components/Select';
import { translate } from '../Services/translation';
import MobileFilterMenu from '../Components/ProductListing/MobileFilterMenu';
import FilterChips from '../Components/Filter/FilterChips';

const CategoryListingContainer = (props) => {
  const {
    description,
    image,
    title,
    hideProductListing,
    hideCategoryBanner,
    pageSizeValues,
  } = props;

  const { totalProducts } = useSelector((state) => state.productListing);

  const getPageSizeFromURL = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const pageSize = searchParams.get('page_size');
    return pageSize ? Number(pageSize) : 25;
  };

  const [currentPageSize, setCurrentPageSize] = useState(getPageSizeFromURL);
  const dropdownString = translate('category.product-per-page');

  const pageSizeOptions = pageSizeValues.map((value) => ({
    value,
    label: `${value} ${dropdownString}`,
  }));

  const handlePageSizeChange = (e) => {
    const selectedSize = Number(e.target.value);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page_size', selectedSize);
    searchParams.set('page', 1);

    window.location.href = `${
      window.location.pathname
    }?${searchParams.toString()}`;
  };

  const pageOptions = pageSizeOptions.map((size) => (
    <option key={size.value} value={size.value}>
      {size.label}
    </option>
  ));

  return (
    <>
      {!hideCategoryBanner && (
        <ListingHeader title={title} description={description} image={image} />
      )}
      {!hideProductListing && (
        <div className="category-listing">
          <div className="category-listing__sidebar">
            <FilterMenu />
          </div>
          <div className="category-listing__main">
            <div className="category-listing__filter-and-select">
              <MobileFilterMenu />
              <LayoutSwitch />
              <FilterChips />
              <div className="category-listing__specific">
                <span>
                  {translate('category.products-found').replace(
                    '{0}',
                    totalProducts
                  )}
                </span>
                <Select
                  className="category-listing__select"
                  value={currentPageSize}
                  onChange={handlePageSizeChange}
                >
                  {pageOptions}
                </Select>
              </div>
            </div>
            <ProductListing />
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryListingContainer;
